<template>
    <div class="view-mode">
        <div class="view-mode-wrap">
            <span class="list-mode" :class="{'active': mode == 1}" @click="changeMode(1)">
                <img v-if="mode == 1" src="../../assets/img/icon/list_mode_black.svg" alt="">
                <img v-else src="../../assets/img/icon/list_mode_gray.svg" alt="">
                列表模式
            </span>
            <span class="map-mode" :class="{'active': mode == 2}" @click="changeMode(2)">
                <img v-if="mode == 2" src="../../assets/img/icon/map_mode_black.svg" alt="">
                <img v-else src="../../assets/img/icon/map_mode_gray.svg" alt="">
                地圖模式
            </span>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    data () {
        return {
        }
    },
    methods: {
        changeMode: function (mode) {
            this.$store.dispatch('setHouseMgtMode', mode)
            if( mode == 1){
                this.$router.push({name: 'HouseManagementDefault'})
            }else if( mode == 2 ){
                this.$router.push({name: 'LandlordMapSearch'})
            }
        }
    },
    computed: {
        ...mapGetters({
            mode: 'GET_HOUSE_MGT_MODE',
        })
    }
}
</script>
<style lang="scss"  >
    .view-mode{
        width: 204px;
        height: 44px;
        border: solid 1px #f0f0f0;
        background-color: #ffffff;
        border-radius: 4px;
        margin-bottom: 24px;
        .view-mode-wrap{
            display: flex;
            padding: 6px;
            span{
                display: flex;
                align-items: center;
                justify-content: center;
                width: 94px;
                height: 32px;
                border-radius: 3px;
                color: #a8a5a4;
                cursor: pointer;
            }
            span.active{
                box-shadow: 0 2px 9px 0 rgba(0, 0, 0, 0.03);
                color: #676362;
                background-color: #f6f6f6;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/widge/MapViewMode.vue